<template>
    <v-dialog
        v-model="dialogModel"
        width="768"
        max-width="95%"
        @click:outside.prevent="closeDialog"
    >
        <v-card>
            <v-card-title class="text-h6 text-md-h5 grey lighten-2">
                <v-row>
                    <v-col cols="10">
                        Reference Authorization and Details
                    </v-col>
                    <v-col cols="2" class="text-right">
                        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="py-5" style="max-height: 75vh; overflow-y: auto;">
                <v-form ref="authDetailsForm" lazy-validation>
                    <!-- Reference 1 -->
                     <div class="mb-4" style="border-bottom:1px solid #e0e0e0">
                         <h2 class="mb-2">Reference 1:</h2>
                         <p class=""> Previous Employer</p>
                    </div>
                    <div>
                        <v-row class="mb-4">
                            <v-col cols="12" md="6">
                                <h3 class="mb-4">Company Name <span class="red--text">*</span></h3>
                                <v-text-field
                                    v-model="form.reference1.companyName"
                                    placeholder="Company Name"
                                    outlined
                                    dense
                                    :rules="[requiredRules]"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="align-end mb-4">
                            <v-col cols="12" md="6" >
                                <h3 class="mb-4">Reference (1) Name <span class="red--text">*</span></h3>
                                <v-text-field
                                    v-model="form.reference1.firstName"
                                    placeholder="First Name"
                                    outlined
                                    dense
                                    hint="First Name"
                                    :persistent-hint="true"
                                    :rules="firstNameRules"
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="form.reference1.lastName"
                                    placeholder="Last Name"
                                    outlined
                                    dense
                                    hint="Last Name"
                                    :persistent-hint="true"
                                    :rules="lastNameRules"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="mb-4">
                            <v-col cols="12" md="6">
                                <h3 class="mb-4">Reference (1) Job Title <span class="red--text">*</span></h3>
                                <v-text-field
                                    v-model="form.reference1.jobTitle"
                                    placeholder="Job Title"
                                    outlined
                                    dense
                                    :rules="[requiredRules]"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="mb-4">
                            <v-col cols="12" md="6">
                                <h3 class="mb-4">Reference (1) Email <span class="red--text">*</span></h3>
                                <v-text-field
                                    v-model="form.reference1.email"
                                    placeholder="example@example.com"
                                    type="email"
                                    outlined
                                    dense
                                    :rules="emailRules"
                                    hint="example@example.com"
                                    :persistent-hint="true"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="mb-4">
                            <v-col cols="12">
                                <h3 class="">Reference (1) Phone Number <span class="red--text">*</span></h3>
                            </v-col>
                            <v-col cols="4" md="2" class="pr-1 pt-0">
                                <v-text-field
                                    v-model="form.reference1.phoneAreaCode"
                                    placeholder="+44"
                                    maxlength="4"
                                    type="number"
                                    outlined
                                    dense
                                    :rules="[requiredRules]"
                                    hint="Area Code"
                                    :persistent-hint="true"
                                />
                            </v-col>
                            <v-col cols="8" md="4" class="pl-1 pt-0">
                                <v-text-field
                                    v-model="form.reference1.phoneNumber"
                                    type="number"
                                    outlined
                                    dense
                                    :rules="[requiredRules]"
                                    hint="Phone Number"
                                    :persistent-hint="true"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="mb-4">
                            <v-col cols="12" md="6">
                                <h3 class="mb-4">Jot Role at Company <span class="red--text">*</span></h3>
                                <v-text-field
                                    v-model="form.reference1.jobRoleAtCompany"
                                    placeholder="Job Role at Company"
                                    outlined
                                    dense
                                    :rules="[requiredRules]"
                                />
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Reference 2 -->
                     <div class="mb-4 pt-5" style="border-bottom:1px solid #e0e0e0">
                         <h2 class="mb-2">Reference 2:</h2>
                         <p class=""> Past employer</p>
                    </div>
                    <div>
                        <v-row class="mb-4">
                            <v-col cols="12" md="6">
                                <h3 class="mb-4">Company Name <span class="red--text">*</span></h3>
                                <v-text-field
                                    v-model="form.reference2.companyName"
                                    placeholder="Company Name"
                                    outlined
                                    dense
                                    :rules="[requiredRules]"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="align-end mb-4">
                            <v-col cols="12" md="6" >
                                <h3 class="mb-4">Reference (2) Name <span class="red--text">*</span></h3>
                                <v-text-field
                                    v-model="form.reference2.firstName"
                                    placeholder="First Name"
                                    outlined
                                    dense
                                    hint="First Name"
                                    :persistent-hint="true"
                                    :rules="firstNameRules"
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="form.reference2.lastName"
                                    placeholder="Last Name"
                                    outlined
                                    dense
                                    hint="Last Name"
                                    :persistent-hint="true"
                                    :rules="lastNameRules"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="mb-4">
                            <v-col cols="12" md="6">
                                <h3 class="mb-4">Reference (2) Job Title <span class="red--text">*</span></h3>
                                <v-text-field
                                    v-model="form.reference2.jobTitle"
                                    placeholder="Job Title"
                                    outlined
                                    dense
                                    :rules="[requiredRules]"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="mb-4">
                            <v-col cols="12" md="6">
                                <h3 class="mb-4">Reference (2) Email <span class="red--text">*</span></h3>
                                <v-text-field
                                    v-model="form.reference2.email"
                                    placeholder="example@example.com"
                                    type="email"
                                    outlined
                                    dense
                                    :rules="emailRules"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="mb-4">
                            <v-col cols="12">
                                <h3 class="">Reference (2) Phone Number <span class="red--text">*</span></h3>
                            </v-col>
                            <v-col cols="4" md="2" class="pr-1 pt-0">
                                <v-text-field
                                    v-model="form.reference2.phoneAreaCode"
                                    placeholder="+44"
                                    outlined
                                    dense
                                    :rules="[requiredRules]"
                                    hint="Area Code"
                                    :persistent-hint="true"
                                    type="number"
                                />
                            </v-col>
                            <v-col cols="8" md="4" class="pl-1 pt-0">
                                <v-text-field
                                    v-model="form.reference2.phoneNumber"
                                    outlined
                                    dense
                                    :rules="[requiredRules]"
                                    hint="Phone Number"
                                    :persistent-hint="true"
                                    type="number"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="mb-4">
                            <v-col cols="12" md="6">
                                <h3 class="mb-4">Job Role at Company <span class="red--text">*</span></h3>
                                <v-text-field
                                    v-model="form.reference2.jobRoleAtCompany"
                                    placeholder="Job Role at Company"
                                    outlined
                                    dense
                                    :rules="[requiredRules]"
                                />
                            </v-col>
                        </v-row>
                    </div>

                    <p class="body-2  pt-4">
                        I authorize Synergy Dental Clinic to contact my references to investigate my past employment and professional activities.
                        I also agree to release from liability all persons and companies providing this information.
                        I understand and acknowledge that any offer of employment is conditional upon Synergy Dental Clinic being completely satisfied with the information provided as a result of this reference check.
                    </p>
                    <v-row class="mb-4 align-end">
                        <v-col cols="12" md="6">
                            <h3 class="mb-4">Full Name <span class="red--text">*</span></h3>
                            <v-text-field
                                v-model="form.fullName.firstName"
                                placeholder="First Name"
                                outlined
                                dense
                                :rules="[requiredRules]"
                                hint="First Name"
                                :persistent-hint="true"
                            />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="form.fullName.lastName"
                                placeholder="Last Name"
                                outlined
                                dense
                                :rules="[requiredRules]"
                                hint="Last Name"
                                :persistent-hint="true"
                            />
                        </v-col>
                    </v-row>
                    <v-row dense class="mt-4">
                        <v-col cols="12">
                            <h3 class="mb-2">Date <span class="red--text">*</span></h3>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-menu
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="form.dateFormatted"
                                        placeholder="DD/MM/YYYY"
                                        readonly
                                        outlined
                                        dense
                                        prepend-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                        :rules="[requiredRules]"
                                        hint="Date"
                                        :persistent-hint="true"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="form.date"
                                    @input="dateMenu = false"
                                />
                            </v-menu>
                        </v-col>
                    </v-row>

                    <div class="mt-5 pt-5" style="border-top:1px solid #e0e0e0">
                        <div class="d-flex justify-end">
                            <v-btn color="primary" :loading="submitLoading" @click="onSubmit">
                                Submit
                            </v-btn>
                        </div>
                    </div>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapActions } from 'vuex'
    import validationRules from '@/common/validationRules'

    const emptyReference = () => ({
        companyName: '',
        firstName: '',
        lastName: '',
        jobTitle: '',
        email: '',
        phoneAreaCode: '',
        phoneNumber: '',
        jobRoleAtCompany: ''
    })

    export default {
        name: 'ReferenceFormDialog',
        props: ['isOpen', 'programme'],

        data: () => ({
            form: {
                reference1: emptyReference(),
                reference2: emptyReference(),
                fullName: { firstName: '', lastName: '' },
                date: null,
                dateFormatted: '',
                formType: 'ReferenceConsentAndDetails'
            },
            loading: false,
            submitLoading: false,
            dateMenu: false,
            firstNameRules: validationRules.firstName,
            lastNameRules: validationRules.lastName,
            requiredRules: validationRules.required,
            emailRules: validationRules.email
        }),

        computed: {
            dialogModel: {
                get () {
                    return this.isOpen
                },
                set (value) {
                    this.$emit('update:isOpen', value)
                }
            }
        },

        watch: {
            'form.date' (val) {
                this.form.dateFormatted = val ? Date.formatDate([val]).trim() : ''
            }
        },

        methods: {
            ...mapActions([
                'uploadReferenceForm', 'showAlert'
            ]),
            buildPayload () {
                return {
                    transitionProgrammeCourseId: this.programme && this.programme.id ? this.programme.id : 0,
                    reference1: { ...this.form.reference1 },
                    reference2: { ...this.form.reference2 },
                    fullName: { ...this.form.fullName },
                    date: this.form.date,
                    formType: this.form.formType
                }
            },
            resetForm () {
                this.form = {
                    reference1: emptyReference(),
                    reference2: emptyReference(),
                    fullName: { firstName: '', lastName: '' },
                    date: null,
                    dateFormatted: '',
                    formType: 'ReferenceConsentAndDetails'
                }
            },
            closeDialog () {
                this.resetForm()
                this.$emit('update:isOpen', false)
            },
            async onSubmit () {
                const formRef = this.$refs.authDetailsForm
                if (!formRef.validate()) {
                    this.showAlert({
                        text: 'Fill all the required fields please',
                        type: 'error'
                    })
                    return
                }

                this.submitLoading = true
                try {
                    const payload = this.buildPayload()
                    await this.uploadReferenceForm(payload)
                    this.$emit('saved')
                    this.closeDialog()
                    if (formRef && formRef.resetValidation) formRef.resetValidation()
                } catch (e) {
                    this.showAlert({
                        text: e.message || 'Error saving form',
                        type: 'error'
                    })
                } finally {
                    this.submitLoading = false
                }
            }
        }
    }
</script>

<style lang="scss">
    .reference-label {
        font-size: 16px;
        font-weight: 600;
        color: #000;
        margin-bottom: 12px;
    }
</style>
